// src/pages/OptOut.jsx
import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import LandingPageNav from "../../components/landingpage/LandingPageNav";
import Footer from "../../components/Footer/footer";
import { apipostPublic } from "../../service/api"; // ✅ import your API helper

const STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
  "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois",
  "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
  "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana",
  "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York",
  "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
  "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
  "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
];

export default function OptOutPage() {
  const [formData, setFormData] = useState({
    loanNumber: "",
    name: "",
    address: "",
    state: "",
    email: "",
    phone: "",
    captcha: false,
  });

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await apipostPublic("optout/add", formData);
      if (res?.status === 201 || res?.data?.message) {
        setSnackbar({ open: true, message: "Opt-Out submitted successfully.", severity: "success" });
        setFormData({
          loanNumber: "",
          name: "",
          address: "",
          state: "",
          email: "",
          phone: "",
          captcha: false,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (err) {
      console.error("Opt-Out submission failed:", err);
      setSnackbar({ open: true, message: "Failed to submit Opt-Out. Please try again.", severity: "error" });
    }
  };

  return (
    <>
      {/* Top navigation */}
      <LandingPageNav />
      <Box sx={(theme) => ({ ...theme.mixins.toolbar })} />

      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Opt-Out
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 3 }}>
            Opt-outs can only be successfully processed if the information provided is accurate to your account.
            If you are unsure of any items on this form, please contact us at <strong>833-270-7191</strong>.
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  label="Loan Number"
                  name="loanNumber"
                  fullWidth
                  value={formData.loanNumber}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="First and Last Name"
                  name="name"
                  fullWidth
                  value={formData.name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Subject Property Street Address *"
                  name="address"
                  required
                  fullWidth
                  value={formData.address}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  select
                  label="Subject Address State *"
                  name="state"
                  required
                  fullWidth
                  value={formData.state}
                  onChange={handleChange}
                >
                  {STATES.map((s) => (
                    <MenuItem key={s} value={s}>
                      {s}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Email Address *"
                  type="email"
                  name="email"
                  required
                  fullWidth
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Phone Number *"
                  name="phone"
                  required
                  fullWidth
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="captcha"
                      checked={formData.captcha}
                      onChange={handleChange}
                    />
                  }
                  label="I'm not a robot"
                />
                <Typography variant="caption" display="block">
                  By clicking the Opt Out button below, you are requesting to limit the sharing of your personal information.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" fullWidth>
                  OPT OUT
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>

      {/* Footer */}
      <Footer />

      {/* Snackbar for success/error messages */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
